import { Component, inject } from '@angular/core';
import { BaryTableDataEnum } from 'models/enums/bary-table.enum';
import { QuotationService } from '../../../../services/quotation.service';

@Component({
  selector: 'jhi-my-quotations-old',
  templateUrl: './my-quotations-old.component.html',
  styleUrls: ['../my-quotations-tab.component.scss'],
})
export class MyQuotationsOldComponent {
  protected readonly quotationsService = inject(QuotationService);
  protected readonly QUOTES = BaryTableDataEnum.QUOTES;
}
